import { render, staticRenderFns } from "./web-header.vue?vue&type=template&id=3674b0b4"
import script from "./web-header.vue?vue&type=script&lang=js"
export * from "./web-header.vue?vue&type=script&lang=js"
import style0 from "./web-header.vue?vue&type=style&index=0&id=3674b0b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports